/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  addBid,
  AddedJobBid,
  fetchAllBids,
  fetchBidsByJobId,
} from '../thunks/bidThunks.ts';

interface BidsState {
  bids: {
    jobId: string;
    userId: string;
    bid: string;
  }[];
  loading: boolean;
  error: string | null;
}

const initialState: BidsState = {
  bids: [],
  loading: false,
  error: null,
};

const bidsSlice = createSlice({
  name: 'bids',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Bids
      .addCase(fetchAllBids.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAllBids.fulfilled,
        (state, action: PayloadAction<AddedJobBid[]>) => {
          state.loading = false;
          state.bids = action.payload;
        },
      )
      .addCase(fetchAllBids.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch bids';
      })

      // Fetch Bids By Job ID
      .addCase(fetchBidsByJobId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchBidsByJobId.fulfilled,
        (
          state,
          action: PayloadAction<
            { jobId: string; userId: string; bid: string }[]
          >,
        ) => {
          state.loading = false;
          state.bids = action.payload;
        },
      )
      .addCase(fetchBidsByJobId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch bids for this job';
      })

      // Add a New Bid
      .addCase(addBid.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        addBid.fulfilled,
        (state, action: PayloadAction<AddedJobBid>) => {
          const bidNew = action.payload;
          state.bids.push(bidNew);
          state.loading = false;
          state.error = null;
        },
      )
      .addCase(addBid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to add bid';
      });
  },
});

const bidsReducer = bidsSlice.reducer;
export default bidsReducer;
